import * as React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'

interface ImageQueryData {
	logoDesktop: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
	logoMobile: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
}

const Logo: React.FC = () => {
	const data = useStaticQuery<ImageQueryData>(graphql`
		query FooterLogoQuery {
			logoDesktop: file(relativePath: { eq: "footer/haw-logo-with-qr.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
			logoMobile: file(relativePath: { eq: "footer/haw-logo-with-qr-mobile.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
		}
	`)

	const logoDesktop = getImage(data.logoDesktop)
	const logoMobile = getImage(data.logoMobile)

	return (
		<>
			<div className="sm:hidden">
				<GatsbyImage
					image={ logoMobile as IGatsbyImageData }
					alt="Health at Work"
				/>
			</div>
			<div className="hidden sm:block">
				<GatsbyImage
					image={ logoDesktop as IGatsbyImageData }
					alt="Health at Work"
				/>
			</div>
		</>
	)
}

export default Logo
